
<div class="dialog-content modify-exam-report-dialog-content">
  <!--title 標題-->
  <h1 class="dialog-title">
    {{ 'modify-exam-report-dialog.title' | translate }}
  </h1>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="dialog-scroll-content">
      <!--檢前資料-->
      <div class="exam-report-block">
        <h2 class="exam-report-block-title">
          {{ 'modify-exam-report-dialog.pre-exam-info' | translate }}
        </h2>

        @if (noticeSendType === API_PARAMS.PRE_EXAM_INFO_DELIVERY_METHOD.AGENT.code) {
        <div class="exam-report-block">
          <div class="exam-report-agent-row">
            <p class="exam-report-block-agent gray-text">
            {{'modify-exam-report-dialog.shipping-address' | translate}}
            </p>
            <p class="exam-report-block-agent">
            {{ 'appointment-info.pick-up-by-agent' | translate }}
            </p>
          </div>
        </div>
        }@else if (noticeSendType === API_PARAMS.PRE_EXAM_INFO_DELIVERY_METHOD.NOT_INDIVIDUAL.code){

        <div class="exam-report-block">
          <div class="exam-report-agent-row">
            <p class="exam-report-block-agent gray-text">
            {{'modify-exam-report-dialog.shipping-address' | translate}}
            </p>
            <p class="exam-report-block-agent">
          {{ 'appointment-info.not-need-to-send' | translate }}
        </p>
          </div>
        </div>
        }

        <div class="input-block">
          @if (noticeSendType === API_PARAMS.PRE_EXAM_INFO_DELIVERY_METHOD.AGENT.code ||
                noticeSendType === API_PARAMS.PRE_EXAM_INFO_DELIVERY_METHOD.NOT_INDIVIDUAL.code) {
          <label class="input-title">{{
            'modify-exam-report-dialog.contact-address' | translate
            }}</label>
          } @else {
          <label class="input-title">{{
            'modify-exam-report-dialog.shipping-address' | translate
            }}</label>
          }
          <div class="input-address-block">
            <div class="input-address-group">
              <mat-form-field appearance="fill" [ngClass]="{
                  'input-error':
                    showFormError &&
                    (form.get('city')?.invalid ||
                      form.get('district')?.invalid ||
                      form.get('address')?.invalid),
                }">
                <mat-select formControlName="city" [placeholder]="
                    'modify-exam-report-dialog.select-city' | translate
                  ">
                  @for (city of cities; track city) {
                  <mat-option [value]="city">{{ city }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill" [ngClass]="{
                  'input-error':
                    showFormError &&
                    (form.get('city')?.invalid ||
                      form.get('district')?.invalid ||
                      form.get('address')?.invalid),
                }">
                <mat-select formControlName="district" [placeholder]="
                    'modify-exam-report-dialog.select-district' | translate
                  " [compareWith]="compareDistricts">
                  <mat-select-trigger>
                    {{ form.get('district')?.value?.areaName }}
                  </mat-select-trigger>
                  @for (district of districts; track district) {
                  <mat-option [value]="district">{{ district.areaName }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="input-address-group">
              <input matInput formControlName="address" [placeholder]="
                  'modify-exam-report-dialog.enter-detailed-address' | translate
                " [ngClass]="{
                  'input-error':
                    showFormError &&
                    (form.get('city')?.invalid ||
                      form.get('district')?.invalid ||
                      form.get('address')?.invalid),
                }" />
            </div>
          </div>

          @if (
          showFormError &&
          (form.get('city')?.invalid ||
          form.get('district')?.invalid ||
          form.get('address')?.invalid)
          ) {
          <mat-error class="input-error-msg">{{
            getPreExamAddressErrorMessage()
            }}</mat-error>
          }
        </div>
      </div>
      <!--檢查報告-->
      <div class="exam-report-block">
        <h2 class="exam-report-block-title">
          {{ 'modify-exam-report-dialog.exam-report' | translate }}
        </h2>
        @if (deliveryType === API_PARAMS.DELIVERY_METHOD.AGENT.code) {
        <div class="exam-report-block">
          <div class="exam-report-agent-row">
            <p class="exam-report-block-agent gray-text">
            {{'modify-exam-report-dialog.shipping-address' | translate}}
            </p>
            <p class="exam-report-block-agent">
            {{ 'appointment-info.pick-up-by-agent' | translate }}
            </p>
          </div>
        </div>
        }@else if (deliveryType === API_PARAMS.DELIVERY_METHOD.NOT_INDIVIDUAL.code || deliveryType === API_PARAMS.DELIVERY_METHOD.OTHER.code){
          <div class="exam-report-block">
          <div class="exam-report-agent-row">
            <p class="exam-report-block-agent gray-text">
            {{'modify-exam-report-dialog.shipping-address' | translate}}
            </p>
            <p class="exam-report-block-agent">
          {{ 'appointment-info.not-need-to-send' | translate }}
        </p>
          </div>
        </div>
        }
         @else {
        <div class="input-block">
          <label class="input-title">{{
            'modify-exam-report-dialog.delivery-method' | translate
            }}</label>
          <mat-radio-group formControlName="deliveryMethod">
            <mat-radio-button [value]="API_PARAMS.DELIVERY_METHOD.DOMESTIC.code">{{ 'modify-exam-report-dialog.domestic'
              | translate }}
            </mat-radio-button>
            <mat-radio-button [value]="API_PARAMS.DELIVERY_METHOD.FOREIGN.code">{{ 'modify-exam-report-dialog.foreign' |
              translate }}
            </mat-radio-button>
            <!--          <mat-radio-button-->
            <!--            [value]="API_PARAMS.DELIVERY_METHOD.DIGITAL_FILE.code">{{ 'modify-exam-report-dialog.digital-file' | translate }}-->
            <!--          </mat-radio-button>-->
          </mat-radio-group>
        </div>

        @if (
        form.get('deliveryMethod')?.value ===
        API_PARAMS.DELIVERY_METHOD.DOMESTIC.code
        ) {
        <div class="input-block address-checkbox-item">
          <label class="input-title">{{
            'modify-exam-report-dialog.shipping-address' | translate
            }}</label>
          <section>
            <div class="input-address-block">
              <div class="input-address-group">
                <mat-form-field appearance="fill" [ngClass]="{
                        'input-error':
                          showFormError &&
                          (form.get('reportCity')?.invalid ||
                            form.get('reportDistrict')?.invalid ||
                            form.get('reportAddress')?.invalid),
                      }">
                  <mat-select formControlName="reportCity" [placeholder]="
                          'modify-exam-report-dialog.select-city' | translate
                        ">
                    @for (city of cities; track city) {
                    <mat-option [value]="city">{{ city }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" [ngClass]="{
                        'input-error':
                          showFormError &&
                          (form.get('reportCity')?.invalid ||
                            form.get('reportDistrict')?.invalid ||
                            form.get('reportAddress')?.invalid),
                      }">
                  <mat-select formControlName="reportDistrict" [placeholder]="
                          'modify-exam-report-dialog.select-district'
                            | translate
                        " [compareWith]="compareDistricts">
                    <mat-select-trigger>
                      {{ form.get('reportDistrict')?.value?.areaName }}
                    </mat-select-trigger>
                    @for (district of reportDistricts; track district) {
                    <mat-option [value]="district">{{
                      district.areaName
                      }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="input-address-group">
                <input matInput formControlName="reportAddress" [placeholder]="
                        'modify-exam-report-dialog.enter-detailed-address'
                          | translate
                      " [ngClass]="{
                        'input-error':
                          showFormError &&
                          (form.get('reportCity')?.invalid ||
                            form.get('reportDistrict')?.invalid ||
                            form.get('reportAddress')?.invalid),
                      }" />
              </div>
            </div>
            @if (
            showFormError &&
            (form.get('reportCity')?.invalid ||
            form.get('reportDistrict')?.invalid ||
            form.get('reportAddress')?.invalid)
            ) {
            <mat-error class="input-error-msg">{{
              getReportAddressErrorMessage()
              }}</mat-error>
            }
          </section>
          <mat-checkbox 
            [checked]="isChecked" 
            [(ngModel)]="isChecked"
            [ngModelOptions]="{standalone: true}"
            (change)="toggleSameAsPreExamInfo($event.checked)" 
            class="address-checkbox">
            {{ 'modify-exam-report-dialog.same-as-pre-exam-info' | translate }}
          </mat-checkbox>
        </div>
        } @else if (
        form.get('deliveryMethod')?.value ===
        API_PARAMS.DELIVERY_METHOD.FOREIGN.code
        ) {
        <div class="input-block">
          <label class="input-title">{{
            'modify-exam-report-dialog.shipping-address' | translate
            }}</label>
          <input matInput formControlName="foreignAddress" [placeholder]="
                  'modify-exam-report-dialog.enter-detailed-address' | translate
                " [ngClass]="{
                  'input-error': showFormError && form.get('foreignAddress'),
                }" />
          @if (showFormError && form.get('foreignAddress')?.invalid) {
          <mat-error class="input-error-msg">{{
            'error.please-fill-in'
            | translate
            : {
            fieldName:
            ('modify-exam-report-dialog.shipping-address'
            | translate),
            }
            }}
          </mat-error>
          }
        </div>
        }
        }

        <!--      @else if (form.get('deliveryMethod')?.value === API_PARAMS.DELIVERY_METHOD.DIGITAL_FILE.code) {-->
        <!--        <p>{{ 'modify-exam-report-dialog.email' | translate }}</p>-->
        <!--        <input matInput formControlName="email"-->
        <!--               [placeholder]="'modify-exam-report-dialog.email-placeholder' | translate"/>-->
        <!--        @if (showFormError && form.get('email')?.invalid) {-->
        <!--          <mat-error>{{ getEmailErrorMessage() }}</mat-error>-->
        <!--        }-->
        <!--      }-->
      </div>

      <!-- 2026/01/27 由PM: 陳亮豪 決定隱藏 -->
      <!-- 收件人資料：非 承辦領取或不須領取時才顯示 -->
      <!-- @if (deliveryType !== '2' && deliveryType !== '3' && deliveryType !== '99') {
        <div class="input-block">
          <label class="input-title">{{
            'appointment-info.report-recipient-info' | translate
            }}</label>
          <mat-radio-group formControlName="deliveryRecipient">
            <mat-radio-button [value]="API_PARAMS.DELIVERY_METHOD.SELF.code">{{
              'appointment-info.report-recipient-self' |
              translate }}
            </mat-radio-button>
            <mat-radio-button [value]="API_PARAMS.DELIVERY_METHOD.NOT_SELF.code">{{
              'appointment-info.report-recipient-notSelf' | translate
              }}
            </mat-radio-button>

            @if (showFormError && form.get('deliveryRecipient')?.invalid) {
            <mat-error class="input-error-msg">{{
              'error.gender-error.required' | translate
              }}</mat-error>
            }
          </mat-radio-group>
        </div> -->
        <!-- 收件人姓名 -->
        <!-- @if(form.get('deliveryRecipient')?.value === API_PARAMS.DELIVERY_METHOD.NOT_SELF.code){
          <div class="input-block">
                <label class="input-title">{{
                  'appointment-info.report-recipient-name' | translate
                  }}</label>
                <input matInput formControlName="recipient" #fieldRef [attr.data-control-name]="'recipient'" [placeholder]="
                        'appointment-info.report-recipient-name' | translate
                      " [ngClass]="{
                        'input-error':
                          showFormError && form.get('recipient')?.invalid,
                      }" />
                @if (showFormError && form.get('recipient')?.invalid) {
                <mat-error class="input-error-msg">{{
                  'error.delivery-recipient-error.required' | translate
                  }}</mat-error>
                }
          </div>
        } -->
        <!-- 收件人電話 -->
         <!-- @if(form.get('deliveryRecipient')?.value === API_PARAMS.DELIVERY_METHOD.NOT_SELF.code){
          <div class="input-block">
                <label class="input-title">{{
                  'appointment-info.report-recipient-cell' | translate
                  }}</label>
                <input matInput formControlName="recipientCell" #fieldRef [attr.data-control-name]="'recipientCell'"
                  [placeholder]="
                        'appointment-info.report-recipient-cell' | translate
                      " [ngClass]="{
                        'input-error':
                          showFormError && form.get('recipientCell')?.invalid,
                      }" />
                @if (showFormError && form.get('recipientCell')?.invalid) {
                <mat-error class="input-error-msg">
                  @if (form.get('recipientCell')?.errors?.['required']) {
                  {{ 'error.phone-error.required' | translate }}
                  }
                  @if (form.get('recipientCell')?.errors?.['invalidFormat']) {
                  {{ form.get('recipientCell')?.errors?.['invalidFormat'] }}
                  }
                </mat-error>
                }
          </div>
        }
      } -->

      
      <!--檢查報告語言-->
      <div class="input-block">
        <label class="input-title">{{
          'modify-exam-report-dialog.report-language' | translate
          }}</label>
        <mat-radio-group formControlName="language">
          @for (language of languages; track language.uno) {
          <mat-radio-button [value]="language.uno">{{
            language.noDesc
            }}
            @if (
            language.uno === API_PARAMS.EXAM_REPORT_LANGUAGE.JAPANESE.code
            ) {
            <span>
              ({{
              'appointment-info.addition-translate-fee' | translate
              }})</span>
            }
          </mat-radio-button>
          }
        </mat-radio-group>
      </div>
    </div>

    <div class="dialog-btn-block">
      <button mat-button class="btn-outline-primary btn-size-l" (click)="closeDialog()" type="button">
        {{ 'common.button.cancel' | translate }}
      </button>
      <button mat-button class="btn-fill-primary btn-size-l" (click)="onSubmit()">
        {{ 'common.button.save-changes' | translate }}
      </button>
    </div>
  </form>
</div>
